export default __webpack_public_path__ + "static/media/angular.94369f6b.svg";